export default __webpack_public_path__ + "static/media/NCRomania.01ee8ea2.png";